import React from 'react';

import { Route } from 'react-router-dom';
import AllowRole from 'src/components/AllowRole';
import AddSeverityPage from 'src/pages/severity/AddSeverity';
import ListSeverityPage from 'src/pages/severity/ListSeverity';

export default function SeverityRoutes() {
	return (
		<>
			<Route path="/severidade" element={<AllowRole role={'admin'} />}>
				<Route
					path="listar"
					element={ <ListSeverityPage /> }
				/>
				<Route
					path="adicionar"
					element={ <AddSeverityPage />}
				/>
			</Route>
		</>
	);
}
